module.exports = __webpack_public_path__ + "static/media/directory2.00350df3.png";